import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-divisa-card',
  templateUrl: './divisa-card.component.html',
  styleUrls: ['./divisa-card.component.scss'],
})
export class DivisaCardComponent {
  @Input() divisa!: any;
  @Output() divisaSelected = new EventEmitter<any>();

  openDialog() {
    this.divisaSelected.emit(this.divisa);
  }
}
